import React from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { CONSTS } from '../../../constants'
const CALENDLY_ID = 'calendly-script'

@inject('store')
@observer
class Calendly extends React.Component {
  handleMessage = (e) => {
    if (e.data.event === 'calendly.event_scheduled') {
      const { productDetails } = this.props
      const { store } = this.props
      const params = {
        first_name: store.sessionData.userData.first_name || '',
        last_name: store.sessionData.userData.last_name || '',
        email: store.sessionData.userData.email || '',
        phone: store.sessionData.userData.phone || '',
        product_id: productDetails.product_id,
        enrollment_type: productDetails.enrollment_type || 'none',
        company_id: productDetails.company_id,
        // we do not want to send notification...calendly will do this
        send_notification: '0',
        reengage: this.props.reengage,
        product_name: productDetails.product_name
      }
      store.enrollSubRequest(params, 'loading')
    }
  }

  UNSAFE_componentWillMount () {
    if (typeof document !== 'undefined') {
      const head = document.querySelector('head')
      const script = document.createElement('script')
      script.setAttribute('id', CALENDLY_ID)
      script.setAttribute('src', CONSTS.CALENDLY_WIDGET_LINK)
      head.appendChild(script)
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('message', this.handleMessage)
    }
  }

  componentWillUnmount () {
    if (typeof document !== 'undefined') {
      const e = document.getElementById(CALENDLY_ID)
      e.parentNode.removeChild(e)
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('message', this.handleMessage)
    }
  }

  render () {
    const { userData } = this.props.store.sessionData
    const companyAddress = `${userData.street_address1} ${userData.street_address2} ${userData.city} ${userData.state} ${userData.zip}`
    const prefillData = `name=${userData.first_name} ${userData.last_name}&email=${userData.email}&a1=${userData.phone}&a2=${userData.firm_name}&a3=${companyAddress}`.replace(/null/g, '')
    const { calendlyLink } = this.props
    return (
      <div
        className="calendly-inline-widget"
        data-url={`${calendlyLink}?${prefillData}`}
        style={{ minWidth: '320px', height: '600px' }}
      />
    )
  }
}

Calendly.propTypes = {
  store: PropTypes.object,
  productDetails: PropTypes.object,
  calendlyLink: PropTypes.string,
  reengage: PropTypes.bool,
  product: PropTypes.object
}

export default Calendly
